export const provincesList = {
  it: [
    {
      name: 'Agrigento',
      id: 'AG',
    },
    {
      name: 'Alessandria',
      id: 'AL',
    },
    {
      name: 'Ancona',
      id: 'AN',
    },
    {
      name: 'Arezzo',
      id: 'AR',
    },
    {
      name: 'Ascoli Piceno',
      id: 'AP',
    },
    {
      name: 'Asti',
      id: 'AT',
    },
    {
      name: 'Avellino',
      id: 'AV',
    },
    {
      name: 'Bari',
      id: 'BA',
    },
    {
      name: 'Barletta-Andria-Trani',
      id: 'BT',
    },
    {
      name: 'Belluno',
      id: 'BL',
    },
    {
      name: 'Benevento',
      id: 'BN',
    },
    {
      name: 'Bergamo',
      id: 'BG',
    },
    {
      name: 'Biella',
      id: 'BI',
    },
    {
      name: 'Bologna',
      id: 'BO',
    },
    {
      name: 'Bolzano/Bozen',
      id: 'BZ',
    },
    {
      name: 'Brescia',
      id: 'BS',
    },
    {
      name: 'Brindisi',
      id: 'BR',
    },
    {
      name: 'Cagliari',
      id: 'CA',
    },
    {
      name: 'Caltanissetta',
      id: 'CL',
    },
    {
      name: 'Campobasso',
      id: 'CB',
    },
    {
      name: 'Carbonia-Iglesias',
      id: 'CI',
    },
    {
      name: 'Caserta',
      id: 'CE',
    },
    {
      name: 'Catania',
      id: 'CT',
    },
    {
      name: 'Catanzaro',
      id: 'CZ',
    },
    {
      name: 'Chieti',
      id: 'CH',
    },
    {
      name: 'Como',
      id: 'CO',
    },
    {
      name: 'Cosenza',
      id: 'CS',
    },
    {
      name: 'Cremona',
      id: 'CR',
    },
    {
      name: 'Crotone',
      id: 'KR',
    },
    {
      name: 'Cuneo',
      id: 'CN',
    },
    {
      name: 'Enna',
      id: 'EN',
    },
    {
      name: 'Fermo',
      id: 'FM',
    },
    {
      name: 'Ferrara',
      id: 'FE',
    },
    {
      name: 'Firenze',
      id: 'FI',
    },
    {
      name: 'Foggia',
      id: 'FG',
    },
    {
      name: 'Forlì-Cesena',
      id: 'FC',
    },
    {
      name: 'Frosinone',
      id: 'FR',
    },
    {
      name: 'Genova',
      id: 'GE',
    },
    {
      name: 'Gorizia',
      id: 'GO',
    },
    {
      name: 'Grosseto',
      id: 'GR',
    },
    {
      name: 'Imperia',
      id: 'IM',
    },
    {
      name: 'Isernia',
      id: 'IS',
    },
    {
      name: "L'Aquila",
      id: 'AQ',
    },
    {
      name: 'La Spezia',
      id: 'SP',
    },
    {
      name: 'Latina',
      id: 'LT',
    },
    {
      name: 'Lecce',
      id: 'LE',
    },
    {
      name: 'Lecco',
      id: 'LC',
    },
    {
      name: 'Livorno',
      id: 'LI',
    },
    {
      name: 'Lodi',
      id: 'LO',
    },
    {
      name: 'Lucca',
      id: 'LU',
    },
    {
      name: 'Macerata',
      id: 'MC',
    },
    {
      name: 'Mantova',
      id: 'MN',
    },
    {
      name: 'Massa-Carrara',
      id: 'MS',
    },
    {
      name: 'Matera',
      id: 'MT',
    },
    {
      name: 'Medio Campidano',
      id: 'VS',
    },
    {
      name: 'Messina',
      id: 'ME',
    },
    {
      name: 'Milano',
      id: 'MI',
    },
    {
      name: 'Modena',
      id: 'MO',
    },
    {
      name: 'Monza e della Brianza',
      id: 'MB',
    },
    {
      name: 'Napoli',
      id: 'NA',
    },
    {
      name: 'Novara',
      id: 'NO',
    },
    {
      name: 'Nuoro',
      id: 'NU',
    },
    {
      name: 'Ogliastra',
      id: 'OG',
    },
    {
      name: 'Olbia-Tempio',
      id: 'OT',
    },
    {
      name: 'Oristano',
      id: 'OR',
    },
    {
      name: 'Padova',
      id: 'PD',
    },
    {
      name: 'Palermo',
      id: 'PA',
    },
    {
      name: 'Parma',
      id: 'PR',
    },
    {
      name: 'Pavia',
      id: 'PV',
    },
    {
      name: 'Perugia',
      id: 'PG',
    },
    {
      name: 'Pesaro e Urbino',
      id: 'PU',
    },
    {
      name: 'Pescara',
      id: 'PE',
    },
    {
      name: 'Piacenza',
      id: 'PC',
    },
    {
      name: 'Pisa',
      id: 'PI',
    },
    {
      name: 'Pistoia',
      id: 'PT',
    },
    {
      name: 'Pordenone',
      id: 'PN',
    },
    {
      name: 'Potenza',
      id: 'PZ',
    },
    {
      name: 'Prato',
      id: 'PO',
    },
    {
      name: 'Ragusa',
      id: 'RG',
    },
    {
      name: 'Ravenna',
      id: 'RA',
    },
    {
      name: 'Reggio di Calabria',
      id: 'RC',
    },
    {
      name: "Reggio nell'Emilia",
      id: 'RE',
    },
    {
      name: 'Rieti',
      id: 'RI',
    },
    {
      name: 'Rimini',
      id: 'RN',
    },
    {
      name: 'Roma',
      id: 'RM',
    },
    {
      name: 'Rovigo',
      id: 'RO',
    },
    {
      name: 'Salerno',
      id: 'SA',
    },
    {
      name: 'Sassari',
      id: 'SS',
    },
    {
      name: 'Savona',
      id: 'SV',
    },
    {
      name: 'Siena',
      id: 'SI',
    },
    {
      name: 'Siracusa',
      id: 'SR',
    },
    {
      name: 'Sondrio',
      id: 'SO',
    },
    {
      name: 'Taranto',
      id: 'TA',
    },
    {
      name: 'Teramo',
      id: 'TE',
    },
    {
      name: 'Terni',
      id: 'TR',
    },
    {
      name: 'Torino',
      id: 'TO',
    },
    {
      name: 'Trapani',
      id: 'TP',
    },
    {
      name: 'Trento',
      id: 'TN',
    },
    {
      name: 'Treviso',
      id: 'TV',
    },
    {
      name: 'Trieste',
      id: 'TS',
    },
    {
      name: 'Udine',
      id: 'UD',
    },
    {
      name: "Valle d'Aosta/Vallée d'Aoste",
      id: 'AO',
    },
    {
      name: 'Varese',
      id: 'VA',
    },
    {
      name: 'Venezia',
      id: 'VE',
    },
    {
      name: 'Verbano-Cusio-Ossola',
      id: 'VB',
    },
    {
      name: 'Vercelli',
      id: 'VC',
    },
    {
      name: 'Verona',
      id: 'VR',
    },
    {
      name: 'Vibo Valentia',
      id: 'VV',
    },
    {
      name: 'Vicenza',
      id: 'VI',
    },
    {
      name: 'Viterbo',
      id: 'VT',
    },
  ],
};
